import React, { useState } from 'react';
import {
    SavedTeamRowContainer,
    SavedHeaderButton,
    SavedHeaderInfo,
    SavedHeaderCircle,
    SavedPlayerRowContainer,
    SavedHeaderClose,
    SavedPlayerRow,
    SavedPlayerName,
    SavedPlayerDetails,
    SavedPlayerItem
} from "./CrewBuilderElements"

const SavedTeamRow = ({ id, team }) => {

    const [displayPlayers, setDisplayPlayers] = useState(false)

    const handleShow = () => e => {
        e.preventDefault()
        setDisplayPlayers(!displayPlayers)
    }

    return (
        <div>
            <SavedTeamRowContainer>
                <SavedHeaderInfo primary={false}>
                    Team {id}
                </SavedHeaderInfo>
                <SavedHeaderButton primary={displayPlayers} onClick={handleShow()}>
                    Show Players
                    {displayPlayers ? (

                        <SavedHeaderClose />
                    ) :
                        <></>
                    }
                </SavedHeaderButton>
            </SavedTeamRowContainer>
            <SavedPlayerRowContainer>
                {displayPlayers ? (
                    team.assetList.map((asset, key) =>
                        <SavedPlayerRow>
                            <SavedPlayerName>{asset.name}</SavedPlayerName>
                            <SavedPlayerDetails>
                                <SavedPlayerItem>{asset.team}</SavedPlayerItem>
                                <SavedPlayerItem>{asset.position}</SavedPlayerItem>
                                <SavedPlayerItem>${asset.currentCost}</SavedPlayerItem>
                                {/* <SavedPlayerItem>{asset.dkPoints}</SavedPlayerItem> */}
                            </SavedPlayerDetails>
                        </SavedPlayerRow>
                    )
                ) :
                    <></>
                }
            </SavedPlayerRowContainer>
        </div>
    )
};

export default SavedTeamRow;